import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserAccessStore } from '../services/user-access/user-access.store';

export const registeredApplicationsGuard: CanActivateFn = () => {
  const store = inject(UserAccessStore);
  const router = inject(Router);

  return store.load().pipe(
    map((access) => {
      if (!access.isDeveloper && !access.isSupport && !access.isAdmin) {
        return router.parseUrl('/no-access');
      }
      if (!access.isSupport && !access.isAdmin) {
        return router.parseUrl('/projects');
      }
      const pref = store.preferredEntry();
      if (access.isDeveloper && pref === 'developer') {
        return router.parseUrl('/projects');
      }
      return true;
    }),
    catchError(() => of(router.parseUrl('/no-access')))
  );
};
